// extracted by mini-css-extract-plugin
export default {"AccordionPanelContent":"AccordionPanelContent__AccordionPanelContent___fItX8","separator":"AccordionPanelContent__separator___xoLcP"};